import {MuiPickersOverrides} from '@material-ui/pickers/typings/overrides';
import {Theme} from '@material-ui/core/styles/createMuiTheme';

export const createMuiPickersMonthSelectionOverrides = ({
    palette,
    spacing,
    typography
}: Theme): MuiPickersOverrides['MuiPickersMonthSelection'] => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        width: '100%',
        height: '250px',
        marginTop: spacing(2),
        color: palette.text.primary,
        "&>[class*='MuiTypography-h5']": {
            '&:focus': {
                color: palette.text.primary
            }
        }
    }
});
